{
  "removeDescription": "Press Delete to remove tag.",
  "removeButtonLabel": "Remove"
}
